import React from 'react';
import { useLocation } from 'react-router-dom';
import { AlertTriangle, ArrowRight, KeyRound, Search } from 'lucide-react';
import BetaLink from '../../beta/BetaLink';

const NotFoundPage = () => {
  const location = useLocation();
  const requestedPath = location.pathname || '/';
  const isAccessTypo = requestedPath.toLowerCase().includes('/acess');

  return (
    <section className="py-20 px-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-8 md:p-10">
          <p className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.18em] text-primary-red uppercase bg-red-50 border border-red-100 px-3 py-1 rounded-full mb-4">
            <AlertTriangle size={14} />
            404 Not Found
          </p>

          <h1 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-3">
            We Couldn&apos;t Find That Page
          </h1>
          <p className="text-gray-600 mb-5">
            The route may be misspelled, outdated, or only available through secure access.
          </p>

          <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 mb-6">
            <p className="text-xs uppercase tracking-wide text-gray-500 font-semibold mb-1">Requested Path</p>
            <code className="text-sm text-gray-800 break-all">{requestedPath}</code>
          </div>

          {isAccessTypo && (
            <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-6">
              <p className="text-sm text-amber-900">
                It looks like you used <code>/acess</code>. The correct route is <code>/access</code>.
              </p>
            </div>
          )}

          <div className="flex flex-wrap gap-3">
            <BetaLink
              to={isAccessTypo ? '/access' : '/'}
              className="inline-flex items-center gap-2 px-5 py-3 bg-primary-red text-white rounded font-semibold hover:bg-primary-red-dark transition-colors"
            >
              {isAccessTypo ? 'Go to Access Portal' : 'Back to Home'}
              <ArrowRight size={16} />
            </BetaLink>
            <BetaLink
              to="/access"
              className="inline-flex items-center gap-2 px-5 py-3 border border-primary-red text-primary-red rounded font-semibold hover:bg-primary-red hover:text-white transition-colors"
            >
              <KeyRound size={15} />
              Secure Access Portal
            </BetaLink>
            <BetaLink
              to="/mirage-recipe"
              className="inline-flex items-center gap-2 px-5 py-3 border border-gray-300 text-gray-800 rounded font-semibold hover:bg-gray-100 transition-colors"
            >
              <Search size={15} />
              Browse Recipes
            </BetaLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFoundPage;
